import React, { useEffect, useRef } from "react";
import { Toast } from "primereact/toast";
import { useSelector } from "react-redux";

export default function ToastContainer() {
    const { showToast } = useSelector((state) => state?.toast);
    const toast = useRef();
    useEffect(() => {
        if (showToast.summary) {
            toast.current.show({ severity: showToast.severity, summary: showToast.summary, detail: showToast.detail, life: 3000 });
        }
    }, [showToast]);

    return <Toast style={{ zIndex: "9999999999999" }} ref={toast} />;
}
